<span class="light" [ngClass]="{ 'is-on': isOn, 'is-off': !isOn }"></span>
<span class="label" *ngIf="label">{{ label }}</span>
